/**
 * Returns Tailwind-like badge colour key based on status string
 */
export function statusColor(status) {
  const map = {
    Active:       'green',
    Collected:    'sky',
    Pending:      'gold',
    Inactive:     'gray',
    Delivered:    'green',
    'In Transit': 'sky',
    Acknowledged: 'sky',
    Approved:     'green',
    Review:       'gold',
    Drying:       'gold',
    Ready:        'sky',
    Completed:    'green',
    Receipt:      'green',
    Payment:      'gold',
    Expense:      'gray',
  };
  return map[status] || 'gray';
}

/**
 * Format a number with Indian locale commas
 */
export function formatINR(amount) {
  return Number(amount).toLocaleString('en-IN');
}

/**
 * Clamp a value between min and max
 */
export function clamp(val, min, max) {
  return Math.min(Math.max(val, min), max);
}
